import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const KEY = "tierpt_install";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch { /* storage off */ } };

/** "Add tierTCG to your home screen" — phones only, from the 2nd visit, never again once dismissed. */
export default function InstallPrompt() {
  const { t } = useI18n();
  const I = t.install;
  const [evt, setEvt] = useState(null);
  const [show, setShow] = useState(false);
  const ios = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

  useEffect(() => {
    const standalone = window.matchMedia?.("(display-mode: standalone)").matches || navigator.standalone;
    if (standalone || window.innerWidth >= 768) return undefined;
    const s = read();
    if (!sessionStorage.getItem(KEY)) { try { sessionStorage.setItem(KEY, "1"); } catch { /* */ } write({ ...s, visits: (s.visits || 0) + 1 }); }
    const forced = new URLSearchParams(window.location.search).has("install");
    const ok = forced || (!s.dismissed && (read().visits || 0) >= 2);
    const onEvt = (e) => { e.preventDefault(); window.__tierInstall = e; setEvt(e); if (ok) setTimeout(() => setShow(true), 4000); };
    window.addEventListener("beforeinstallprompt", onEvt);
    if (ok && (ios || forced)) setTimeout(() => setShow(true), forced ? 300 : 4000);
    return () => window.removeEventListener("beforeinstallprompt", onEvt);
  }, [ios]);

  if (!show) return null;
  const close = () => { setShow(false); write({ ...read(), dismissed: true }); };
  const install = async () => { if (!evt) return; evt.prompt(); await evt.userChoice.catch(() => null); close(); };

  return (
    <div className="fixed inset-x-3 z-40 tier-install" style={{ bottom: "calc(var(--tabbar-h, 0px) + 12px + env(safe-area-inset-bottom, 0px))" }} role="dialog" aria-label={I.title} data-testid="install-prompt">
      <div className="flex items-center gap-3 bg-[#16161b] border border-amber-500/30 rounded-sm p-3 shadow-[0_12px_40px_-12px_rgba(0,0,0,.8)]">
        <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-[10px] shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="text-sm font-bold text-stone-100 leading-tight">{I.title}</div>
          <div className="text-[11.5px] text-stone-400 leading-snug mt-0.5">{ios || !evt ? I.ios : I.text}</div>
        </div>
        {!ios && evt && (
          <button type="button" onClick={install} className="btn-gold shrink-0 px-3 py-2 text-[10px] font-bold uppercase tracking-[0.16em] rounded-sm">{I.add}</button>
        )}
        <button type="button" onClick={close} aria-label={I.close} className="shrink-0 p-1 text-stone-500 hover:text-stone-200"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
